export enum AppRoutes {
  Webinar = "/",
  WebinarB = "/peak",
  Upsell = "/all-in",
  Downsell = "/group-coaching",
  UnlimitedShops = "/unlimited-shops",
  Thanks = "/thank-you",
}
